import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AiChatBotMessage {
    public changeState$ = new BehaviorSubject<boolean>(false);
}